import React, { useState } from 'react';
import { PAGES } from 'routes';
import { pushTo } from 'containers/services/routes-helper';
import NavigationButtons from 'components/navigationButtons';
import messages from 'containers/IdentificationPage/messages';
import { translate } from 'containers/services/translate';
import { BUTTON_COLORS } from 'constants/design';
import { ArrowForwardIos } from '@material-ui/icons';
import { IntlShape, injectIntl } from 'react-intl';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import Document from 'components/Document';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { requestUtils } from 'helpers/saga-helpers';
import { FEATURES } from 'features/features';
import * as featureService from 'features/fflip-helpers';
import { renderWarningMessage } from 'containers/IdentificationPage/utils';
import {
  SupportDocumentContainer,
  Content,
  CallToAction,
  NoResults,
} from 'containers/IdentificationPage/SearchResults/styles';
import PreOuvertureModal from 'containers/IdentificationPage/SearchResults/PreOuvertureModal';

export interface SearchResultsProps {
  intl: IntlShape;
  policyExists: Boolean;
  claimExists: Boolean;
  isRejected: boolean;
  policyNumber: string;
  requestSupportDocuments: Function;
  enablePreOpenClaim: boolean;
  isOpen?: any;
  isPreOpeningManager?: boolean;
  corporealClaim: any;
  listings: any;
  requestGetReportsPolicy: Function;
}

const NoResultWithPreOpen: React.FC<SearchResultsProps> = (
  props,
): JSX.Element => {
  const [open, setOpen] = useState(false);

  const handleContinue = type => {
    if (type === 'normal') {
      props.isPreOpeningManager
        ? pushTo(PAGES.PREOPEN_CLAIM_PREOPEN_MANAGER, {
            isUsageOpening: false,
          })()
        : pushTo(PAGES.PREOPENING)();
    } else {
      props.isPreOpeningManager
        ? pushTo(PAGES.PREOPEN_CLAIM_PREOPEN_MANAGER, {
            isUsageOpening: true,
          })()
        : pushTo(PAGES.PREOPENING)();
    }
  };
  return (
    <NoResults>
      <Content color={props.isRejected || props.isOpen ? 'red' : ''}>
        {renderWarningMessage(props)}
      </Content>
      {props.policyExists && !props.claimExists && props.enablePreOpenClaim && (
        <>
          <CallToAction>
            <PrimaryButton
              onClick={() => {
                props.isPreOpeningManager &&
                featureService.hasFeature(FEATURES.OPENING_BY_USAGE)
                  ? setOpen(true)
                  : props.isPreOpeningManager
                  ? pushTo(PAGES.PREOPEN_CLAIM_PREOPEN_MANAGER)()
                  : pushTo(PAGES.PREOPENING)();
              }}
              title={translate(
                { ...messages.identificationPagePreOpeningButton },
                props,
              )}
              lefticon={<ArrowForwardIos className="buttonIcon" />}
              background={BUTTON_COLORS.PRIMARY_BLUE}
              border={BUTTON_COLORS.PRIMARY_BLUE}
              titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
            />
            <SecondaryButton
              onClick={
                props.isPreOpeningManager
                  ? pushTo(PAGES.PREOPEN_MANAGER_HOME)
                  : pushTo(PAGES.IDENTIFICATION)
              }
              title={translate({ ...messages.homePage }, props)}
            />
            <NavigationButtons isPreOpen />
          </CallToAction>
          <SupportDocumentContainer>
            <Document
              name={translate({ ...messages.support_document_cp }, props)}
              type={translate({ ...messages.support_document_cp }, props)}
              icon={
                <VisibilityIcon
                  className="consult"
                  onClick={() =>
                    props.requestGetReportsPolicy(
                      `${requestUtils.getApiBasePath()}/corporeal/reports/${
                        props.policyNumber
                      }/COND_PART_MONO/0`,
                    )
                  }
                />
              }
            />
            <Document
              name={translate(
                { ...messages.support_document_attestationDefinitive },
                props,
              )}
              type={translate(
                { ...messages.support_document_attestationDefinitive },
                props,
              )}
              icon={
                <VisibilityIcon
                  className="consult"
                  onClick={() =>
                    props.requestGetReportsPolicy(
                      `${requestUtils.getApiBasePath()}/corporeal/reports/${
                        props.policyNumber
                      }/AttestationDefinitive/0`,
                    )
                  }
                />
              }
            />
          </SupportDocumentContainer>
          <PreOuvertureModal
            open={open}
            onClose={() => setOpen(false)}
            onContinue={handleContinue}
          />
        </>
      )}
    </NoResults>
  );
};

export default injectIntl(NoResultWithPreOpen);
